var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8105 5C10.8105 8 6.81055 11 6.81055 11C6.81055 11 2.81055 8 2.81055 5C2.81055 3.93913 3.23197 2.92172 3.98212 2.17157C4.73227 1.42143 5.74968 1 6.81055 1C7.87141 1 8.88883 1.42143 9.63897 2.17157C10.3891 2.92172 10.8105 3.93913 10.8105 5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81055 6.5C7.63897 6.5 8.31055 5.82843 8.31055 5C8.31055 4.17157 7.63897 3.5 6.81055 3.5C5.98212 3.5 5.31055 4.17157 5.31055 5C5.31055 5.82843 5.98212 6.5 6.81055 6.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3);
export default __webpack_public_path__ + "static/media/SVG (3).e4cfc9315cc92417316ffcc6d4bc580c.svg";
export { ForwardRef as ReactComponent };